import { render, staticRenderFns } from "./GerarRelatorioComissoes.vue?vue&type=template&id=181c7b1a&scoped=true&"
import script from "./GerarRelatorioComissoes.vue?vue&type=script&lang=js&"
export * from "./GerarRelatorioComissoes.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatorioComissoes.vue?vue&type=style&index=0&id=181c7b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c7b1a",
  null
  
)

export default component.exports